import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b963c32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "btn-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "13",
    fill: "currentColor",
    class: "bi bi-search",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Area", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Anaquel", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Fila", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Areas por Almacenes")
], -1))
const _hoisted_15 = { class: "card overflow-scroll" }
const _hoisted_16 = { class: "table table-hover table-sm" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Almacen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Area"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripcion"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "btn-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Anaqueles")
], -1))
const _hoisted_29 = { class: "card overflow-scroll" }
const _hoisted_30 = { class: "table table-hover table-sm" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Anaquel"),
    /*#__PURE__*/_createElementVNode("th", null, "Cara"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "btn-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Ubicaciones")
], -1))
const _hoisted_43 = { class: "card overflow-scroll" }
const _hoisted_44 = { class: "table table-hover table-sm" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fila"),
    /*#__PURE__*/_createElementVNode("th", null, "Columna"),
    /*#__PURE__*/_createElementVNode("th", null, "Ubicacion"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "btn-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_53 = [
  _hoisted_52
]

import { ref, onMounted, computed,Ref } from 'vue';
import axios from 'axios';
import { Logarea, Loganaquel, Logubica} from '@/interface/interfaces';
import UpLogArea from './pUpdate/UpLogArea.vue';
import InLogArea from './pInsert/InLogArea.vue';
import DlLogArea from './pDelete/DlLogArea.vue';
import InLogAnaquel from './pInsert/InLogAnaquel.vue';
import UpLogAnaquel from './pUpdate/UpLogAnaquel.vue';
import DlLogAnaquel from './pDelete/DlLogAnaquel.vue';
import InLogUbica from './pInsert/InLogUbica.vue';
import UpLogUbica from './pUpdate/UpLogUbica.vue';
import DlLogUbica from './pDelete/DlLogUbica.vue';

import { UrlGlobal } from '@/store/dominioGlobal';
import { stringifyQuery } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LogUbica',
  setup(__props) {

const dUrl = UrlGlobal()
const search = ref('')
const options = ref('')
const varP = ref(0)
//const cara = ref('')
const nom_status = ref('')
let carau = String
//const fila = ref('')
//const columna = ref('')
const ubicacion = ref('')

//-----------------------------------------------------------------
const logarea = ref<Array<Logarea>>([]);

const getLogarea = () => { 
        axios.get(dUrl.urlGlobal +'/api2/logarea/')
            .then(response => {
                logarea.value = response.data;
        
            let almacen = response.data.almacen
            let area = response.data.area

            })
            .catch(error => {
                console.error('Error fetching cargos:', error);
            });
};
//----------------------------------------------------------------
const loganaquelz = ref<Array<Loganaquel>>([])
const getLoganaquel = (id_almacen: any, id_area: any, id_descripcion: any, id_status: any) => {
     
        axios.get(`${dUrl.urlGlobal}/api2/logarea/loganaquel?id_area=${id_area}&id_almacen=${id_almacen}`)
            .then(response => { console.log(response.data)
                loganaquelz.value = response.data; 

                almacen = id_almacen
                area = id_area
                descripcion = id_descripcion
                status = id_status

                if (clickUp.value == true || clickDl.value == true) {
                    FunClick(almacen, area, status, null, null, null, null, null, descripcion)

                }
                
            })
            .catch(error => {
                console.error('Error fetching loganaquel:', error);
        });
    }
//};
//----------------------------------------------------------------
const logubica = ref<Array<Logubica>>([])
const getLogubica = (id_cara: any, id_anaquel: any, id_area: any, id_almacen: any) => {
    axios.get(`${dUrl.urlGlobal}/api2/loganaquel/logubica?id_cara=${id_cara}&id_anaquel=${id_anaquel}&id_area=${id_area}&id_almacen=${id_almacen}`)
        .then(response => {
            logubica.value = response.data;

            cara = id_cara
            anaquel = id_anaquel
            area = id_area
            //status = id_status
            almacen = id_almacen
            //fila = id_fila
            //columna.value = id_columna

            if (clickLaUp.value == true || clickLaDl.value == true) {
                    FunClick(almacen, area, status, anaquel, cara, null, null, null, null)

                }
        })
        .catch(error => {
            console.error('Error fetching logubica:', error);
        });
};
//-----------------------------------------------------------------
// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return logarea.value;
    } else if (options.value == 'Area') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return logarea.value.filter(elm => {
            return (
                elm.almacen?.toLowerCase().includes(searchTerm) ||
                elm.nom_almacen?.toLowerCase().includes(searchTerm) ||
                elm.area?.toLowerCase().includes(searchTerm) ||
                elm.descripcion?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return logarea.value
    }
});
//----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return loganaquelz.value;

    } else if (options.value == 'Anaqueles') {
        const searchTerm = search.value.toLowerCase();

        return loganaquelz.value.filter(elm => {
            return (
                elm.anaquel?.toLowerCase().includes(searchTerm) ||
                elm.cara?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm) 
            );
        });
    }else{
        return loganaquelz.value
    }
});

//----------------------------------------------------------------
const filteredCarga3 = computed(() => {
    if (search.value === '') {
        return logubica.value;
    } else if (options.value == 'Ubicaciones') {
        const searchTerm = search.value.toLowerCase();
        return logubica.value.filter(elm => {
            return (
                elm.fila?.toLowerCase().includes(searchTerm) ||
                elm.columna?.toLowerCase().includes(searchTerm) ||
                elm.ubicacion?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return logubica.value
    }
});


//funcion de los botones y las extenciones de Insert,delete,update----------------
let almacen : any
let descripcion : any
let area : any
let anaquel: any 
let cara: any
let fila: any
let columna: any
let status: any

let btnUp = ref(false);//variable para mostrar modal de update
let clickUp = ref(false)//variable para activar el click de Up
let btnIn = ref(false);//variable modal insert
let btnDl = ref(false);//variable para mostrar modal del delete
let clickDl = ref(false);//variable para activar el click del delete

let btnLaUp = ref(false);
let clickLaUp = ref(false);
let btnLaIn = ref(false);
let btnLaDl = ref(false);
let clickLaDl = ref(false);

let btnLuUp = ref(false);
let clickLuUp = ref(false);
let btnLuIn = ref(false);
let btnLuDl = ref(false);
let clickLuDl = ref(false);


//funciones q activan el click y en el caso del insert muestran el modal
const CbtnUp = () => {
  clickUp.value = !clickUp.value
  clickDl.value = false
}
const CbtnIn = () => {
  btnIn.value = !btnIn.value
  clickUp.value = false
  clickDl.value = false
}

const CbtnDl = () => {
  clickDl.value = !clickDl.value
  clickUp.value = false
}

const CbtnLaIn = () => {
  btnLaIn.value = !btnLaIn.value
  clickLaUp.value = false
  clickLaDl.value = false
}
const CbtnLaUp = () => {
  clickLaUp.value = !clickLaUp.value
  clickLaDl.value = false
}

const CbtnLaDl = () => {
  clickLaDl.value = !clickLaDl.value
  clickLaUp.value = false
}

const CbtnLuUp = () => {
  clickLuUp.value = !clickLuUp.value
  clickLuDl.value = false
}
const CbtnLuIn = () => {
  btnLuIn.value = !btnLuIn.value
  clickLuUp.value = false
  clickLuDl.value = false
}

const CbtnLuDl = () => {
  clickLuDl.value = !clickLuDl.value
  clickLuUp.value = false
}
//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const FunClick = (al: any, ar: any, st: any, an: any, ca: any, fi: any, co: any, de: any, ub: any) => {
  let almacen = al;
  let area = ar;
  let status = st;
  let anaquel = an;
  let cara = ca;
  let fila = fi;
  let columna = co;
  let descripcion = de;
  let ubicacion = ub;

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  }
  if (clickDl.value == true) {
    btnDl.value = !btnDl.value
    clickDl.value = !clickDl.value
  }

  if (clickLaUp.value == true) {
    btnLaUp.value = !btnLaUp.value
    clickLaUp.value = !clickLaUp.value
  }

  if (clickLaDl.value == true) {
    btnLaDl.value = !btnLaDl.value
    clickLaDl.value = !clickLaDl.value
  }

  if (clickLuUp.value == true) {
    btnLuUp.value = !btnLuUp.value
    clickLuUp.value = !clickLuUp.value
  }

  if (clickLuDl.value == true) {
    btnLuDl.value = !btnLuDl.value
    clickLuDl.value = !clickLuDl.value
  }
}

//funciones de emits para actualizar las variables y cierre los modales activos sea de update o insert
function updLogareaPropsValue(newValue: boolean) {
  btnUp.value = newValue
  //almacen.value = almacen
  //area.value = area
  //descripcion.value = descripcion
  //status.value = status

  getLogarea()  
}

//function insertPropsValue(newValue: boolean, var1: number) {
//  btnIn.value = newValue,
//  varP.value = var1
//  if (varP.value == 1){
//    getLogarea();
//  }
//  if (varP.value == 2){
//    getLogarea();
//  }
//}

function insLogareaPropsValue(newValue: boolean) {
  btnIn.value = newValue
  getLogarea();   
}

function delLogareaPropsValue(newValue: boolean, almacen: any, area: any) {
  btnDl.value = newValue
  almacen.value = String
  area.value = String

  getLogarea()
}
//---- Anaqueles
function updLoganaquelPropsValue(newValue: boolean, almacen: any, area: any, status: any, anaquel: any, cara: any) {
  btnLaUp.value = newValue
  almacen.value = almacen
  area.value = area
  anaquel.value = anaquel
  cara.value = cara
  status.value = status

  getLoganaquel(almacen, area, null, null)  
}

function insLoganaquelPropsValue(newValue: boolean, almacen: any, area: any ) {
  btnLaIn.value = newValue
  almacen.value = almacen
  area.value = area

  getLoganaquel(almacen, area, null, null);   
}

function delLoganaquelPropsValue(newValue: boolean, almacen: any, area: any, anaquel: any, cara: any) {
  btnLaDl.value = newValue
  almacen.value = almacen
  area.value = area
  anaquel.value = anaquel
  cara.value = cara

  getLoganaquel(almacen, area, null, null)
}
//--Ubicaciones    -----------------------------------------------------------------//almacen: any, area: any, anaquel: any, cara: any)
function updLogubicaPropsValue(newValue: boolean) {
  btnUp.value = newValue
  status.value = status
  fila.value = fila
  columna.value = columna
  //ubicacion.value = ubicacion
  //almacen.value = almacen
  //area.value = area
  //anaquel.value = anaquel
  //cara.value = cara

    getLogubica(almacen, area, anaquel, cara)  
}

function insLogubicaPropsValue(newValue: boolean, almacen: any, area: any, anaquel: any, carau: any ) {
  btnIn.value = newValue
  almacen.value = almacen
  area.value = area
  anaquel.value = anaquel
  cara.value = carau

    getLogubica(almacen, area, anaquel, cara);   
}

function delLogubicaPropsValue(newValue: boolean, almacen: any, area: any, anaquel: any, cara: any, fila: any, columna: any) {
  btnDl.value = newValue
  almacen.value = almacen
  area.value = area
  anaquel.value = anaquel
  cara.value = cara
  fila.value = fila
  columna.value = columna

    getLogubica(almacen, area, anaquel, cara)
}
//-----------------------------------------------------------------------------------------------------------------------

onMounted(() => {
    getLogarea();
    getLoganaquel("1", "1", null, null);
    getLogubica("1", "1", "1", "1")
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "search",
              id: "search",
              placeholder: "Buscar",
              style: {"background-color":"transparent","border":"none","outline":"none","color":"white"},
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event))
            }, null, 512), [
              [_vModelText, search.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              style: {"background-color":"transparent","border":"none","outline":"none","color":"black"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options).value = $event))
            }, _hoisted_10, 512), [
              [_vModelSelect, options.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.area,
                        onClick: ($event: any) => (getLoganaquel(elm.almacen, elm.area, elm.descripcion, elm.status))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.almacen), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_almacen), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.area), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.descripcion), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 8, _hoisted_18))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: _withModifiers(CbtnIn, ["prevent"])
                }, _hoisted_21),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: _withModifiers(CbtnUp, ["prevent"])
                }, _hoisted_23),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: _withModifiers(CbtnDl, ["prevent"])
                }, _hoisted_25)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("table", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga2.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.area,
                        onClick: ($event: any) => (getLogubica(elm.cara, elm.anaquel, elm.area, elm.almacen ))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.anaquel), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.cara), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 8, _hoisted_32))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: _withModifiers(CbtnLaIn, ["prevent"])
                }, _hoisted_35),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: _withModifiers(CbtnLaUp, ["prevent"])
                }, _hoisted_37),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: _withModifiers(CbtnLaDl, ["prevent"])
                }, _hoisted_39)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("table", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga3.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.ubicacion,
                        onClick: ($event: any) => (FunClick(elm.almacen, elm.area, elm.status, elm.anaquel, elm.cara, elm.fila, elm.columna, elm.ubicacion, null))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fila), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.columna), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.ubicacion), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 8, _hoisted_46))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: _withModifiers(CbtnLuIn, ["prevent"])
                }, _hoisted_49),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: _withModifiers(CbtnLuUp, ["prevent"])
                }, _hoisted_51),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: _withModifiers(CbtnLuDl, ["prevent"])
                }, _hoisted_53)
              ])
            ])
          ])
        ]),
        (_unref(btnUp))
          ? (_openBlock(), _createBlock(UpLogArea, {
              key: 0,
              almacen: _unref(almacen),
              area: _unref(area),
              descripcion: _unref(descripcion),
              status: _unref(status),
              btnUp: _unref(btnUp),
              onUpdProps: updLogareaPropsValue
            }, null, 8, ["almacen", "area", "descripcion", "status", "btnUp"]))
          : _createCommentVNode("", true),
        (_unref(btnIn))
          ? (_openBlock(), _createBlock(InLogArea, {
              key: 1,
              btnIn: _unref(btnIn),
              onInsertProps: insLogareaPropsValue
            }, null, 8, ["btnIn"]))
          : _createCommentVNode("", true),
        (_unref(btnDl))
          ? (_openBlock(), _createBlock(DlLogArea, {
              key: 2,
              btnDl: _unref(btnDl),
              almacen: _unref(almacen),
              area: _unref(area),
              onDeleteProps: delLogareaPropsValue
            }, null, 8, ["btnDl", "almacen", "area"]))
          : _createCommentVNode("", true),
        (_unref(btnLaUp))
          ? (_openBlock(), _createBlock(UpLogAnaquel, {
              key: 3,
              almacen: _unref(almacen),
              area: _unref(area),
              status: _unref(status),
              anaquel: _unref(anaquel),
              cara: _unref(cara),
              btnLaUp: _unref(btnLaUp),
              onUpdLaProps: updLoganaquelPropsValue
            }, null, 8, ["almacen", "area", "status", "anaquel", "cara", "btnLaUp"]))
          : _createCommentVNode("", true),
        (_unref(btnLaIn))
          ? (_openBlock(), _createBlock(InLogAnaquel, {
              key: 4,
              btnLaIn: _unref(btnLaIn),
              almacen: _unref(almacen),
              area: _unref(area),
              status: _unref(status),
              onInsLaProps: insLoganaquelPropsValue
            }, null, 8, ["btnLaIn", "almacen", "area", "status"]))
          : _createCommentVNode("", true),
        (_unref(btnLaDl))
          ? (_openBlock(), _createBlock(DlLogAnaquel, {
              key: 5,
              btnLaDl: _unref(btnLaDl),
              almacen: _unref(almacen),
              area: _unref(area),
              anaquel: _unref(anaquel),
              cara: _unref(cara),
              onDelLaProps: delLoganaquelPropsValue
            }, null, 8, ["btnLaDl", "almacen", "area", "anaquel", "cara"]))
          : _createCommentVNode("", true),
        (_unref(btnLuUp))
          ? (_openBlock(), _createBlock(UpLogUbica, {
              key: 6,
              status: _unref(status),
              anaquel: _unref(anaquel),
              cara: _unref(cara),
              fila: _unref(fila),
              columna: _unref(columna),
              ubicacion: ubicacion.value,
              btnLuUp: _unref(btnLuUp),
              onUpdLuProps: updLogubicaPropsValue
            }, null, 8, ["status", "anaquel", "cara", "fila", "columna", "ubicacion", "btnLuUp"]))
          : _createCommentVNode("", true),
        (_unref(btnLuIn))
          ? (_openBlock(), _createBlock(InLogUbica, {
              key: 7,
              btnLuIn: _unref(btnLuIn),
              almacen: _unref(almacen),
              area: _unref(area),
              anaquel: _unref(anaquel),
              cara: _unref(cara),
              onInLuProps: insLogubicaPropsValue
            }, null, 8, ["btnLuIn", "almacen", "area", "anaquel", "cara"]))
          : _createCommentVNode("", true),
        (_unref(btnLuDl))
          ? (_openBlock(), _createBlock(DlLogUbica, {
              key: 8,
              btnLuDl: _unref(btnLuDl),
              almacen: _unref(almacen),
              area: _unref(area),
              anaquel: _unref(anaquel),
              cara: _unref(cara),
              fila: _unref(fila),
              columna: _unref(columna),
              onDelLuProps: delLogubicaPropsValue
            }, null, 8, ["btnLuDl", "almacen", "area", "anaquel", "cara", "fila", "columna"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})